<div class="organization-badge">
  @if (adminService.organization()?.accountLogoDownloadLink) {
    <img class="organization-badge_logo" [src]="adminService.organization().accountLogoDownloadLink" [alt]="adminService.organization()?.name" />
  }
  <span class="organization-badge_org-name">{{ adminService.organization()?.name }}</span>
  <mat-divider class="organization-badge_divider" [vertical]="true"></mat-divider>
  <div class="organization-badge_license">
    <span>{{ 'ORGANIZATION.CONVERSION_LICENSE' | translate }}:</span>
    <span>
      {{ ((adminService.organization() | wrapFn: hasContentCustomLicence) ? 'ORGANIZATION.CUSTOM' : 'ORGANIZATION.STANDARD') | translate }}
    </span>
  </div>
</div>
